import { EpimsBaseEntityDto } from './epim-base.dto';

export class DamageListDto extends EpimsBaseEntityDto {

    DamageId: string;	
    ItemName: string;
    OptApprovedRate: string;
    CompanyApprovedRate: string;
    SubscriberId: string;
    ItemTypeId: string;z
    SubscriptionUserId: string;
    MeasureName: string;
    Remark: string;
    MeasureId: string;
    DamageStatusId: string;
    CreatedAt: string;
    CreatedBy: string;
    Uom: string;
    UomId: string;
    SiteId:string;
    dateCreated	:Date;
    dateUpdated	:Date;
    CreatedById	:string;
    ModifiedById:string;	
    id	:string;
            
}